import { getItem, setItem } from 'owa-local-storage';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';
import isDeepLink from 'owa-url/lib/isDeepLink';

const LOCAL_STORAGE_KEY = 'CopilotChatDrawerUserPreferredWidth';

export function saveCopilotChatDrawerWidth(targetWindow: Window, width: number): void {
    if (isPopout(targetWindow) || isDeepLink()) {
        return;
    }
    try {
        setItem(window, LOCAL_STORAGE_KEY, width.toString());
    } catch {
        // Silently fail if localStorage is unavailable
    }
}

export function getSavedCopilotChatDrawerWidth(): number | null {
    try {
        const stored = getItem(window, LOCAL_STORAGE_KEY);
        if (stored === null) {
            return null;
        }
        const width = parseFloat(stored);
        return isNaN(width) ? null : width;
    } catch {
        return null;
    }
}
